import React, { FC, useEffect, useState, memo } from 'react';
import {
  getTimeDifference,
  getTimeWithTimeZone,
} from 'utils/helpers/momentTime';
import { Draggable } from 'react-beautiful-dnd';
import Modal from 'components/common/modal/modal';
import { IEvents } from 'types';
import moment from 'moment';
import Delete from 'style/imgs/icons/delete-icon.svg';
import RecurringModal from './recurringModal';
import styles from './index.module.scss';

const PX_IN_MIN = 1.33;

interface IEventProps {
  handleEdit: (event: IEvents) => void;
  deleteEvent?: (
    unitId: number,
    eventId: number,
    repeatAction?: string
  ) => void;
  day: moment.Moment;
  event: IEvents;
  idx: number;
  diff: number;
  daysToShow: number;
  activeScholarId: number | undefined;
}
const Event: FC<IEventProps> = ({
  event,
  idx,
  day,
  diff,
  handleEdit,
  daysToShow,
  deleteEvent,
  activeScholarId,
}) => {
  const startTime = getTimeWithTimeZone(event.startTimeStr || '00:00', 'HH:mm');
  const endTime = getTimeWithTimeZone(event.endTimeStr || '00:00', 'HH:mm');
  const diffInTime = getTimeDifference(day, startTime, endTime);
  const [eventHeight, setEventHeight] = useState<number>(
    diffInTime * PX_IN_MIN
  );
  const [timeRange, setTimeRange] = useState<number>();
  const [isModalOpen, setModalOpen] = useState(false);

  const handleOpen = () => setModalOpen(!isModalOpen);

  useEffect(() => {
    const height = diffInTime * PX_IN_MIN;
    setTimeRange(diffInTime);
    setEventHeight(height);
  }, [startTime, day, endTime, diffInTime]);

  const handleDeleteEvent = (type?: string) => {
    if (deleteEvent && event.id && activeScholarId) {
      deleteEvent(activeScholarId, event.id, type);
    }
  };
  return (
    <Draggable
      key={event.id}
      draggableId={`${event.id}_${timeRange}`}
      index={idx}
      isDragDisabled
    >
      {(provided) => {
        return (
          <div
            className={styles.cell}
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            onClick={(e) => {
              e.stopPropagation();
              handleEdit(event);
            }}
            role="button"
            onKeyDown={(e) => {
              e.stopPropagation();
              handleEdit(event);
            }}
            tabIndex={0}
          >
            {daysToShow !== 1 ? (
              <span
                style={{ height: eventHeight, top: `${PX_IN_MIN * diff}px` }}
              >
                {event.title}
              </span>
            ) : (
              <div
                style={{ height: eventHeight, top: `${PX_IN_MIN * diff}px` }}
                className={styles.eventView}
              >
                <div>
                  <div>
                    <span>{`${
                      event.subject.charAt(0).toUpperCase() +
                      event.subject.slice(1)
                    } `}</span>
                    {event.link && <a href={event.link}>{event.link}</a>}
                  </div>
                  <span>{`${moment(startTime, 'HH:mm').format('LT')} - ${moment(
                    endTime,
                    'HH:mm'
                  ).format('LT')}`}</span>
                </div>
                <div>
                  {event.repeat ? (
                    <Modal
                      trigger={
                        <button
                          type="button"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleOpen();
                          }}
                          className={styles.trash}
                        >
                          <img src={Delete} alt="delete event" />
                        </button>
                      }
                      modalContent={
                        <RecurringModal
                          modalType="delete"
                          action={handleDeleteEvent}
                          closeModal={handleOpen}
                        />
                      }
                      isOpen={isModalOpen}
                      modalOpen={handleOpen}
                    />
                  ) : (
                    <button
                      type="button"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleDeleteEvent();
                      }}
                      className={styles.trash}
                    >
                      <img src={Delete} alt="delete event" />
                    </button>
                  )}
                </div>
              </div>
            )}
          </div>
        );
      }}
    </Draggable>
  );
};

export default memo(Event);
